import React from 'react'
import Modal from 'react-modal'
import _ from 'lodash'

const BkFlowReservationPropertyPoliciesModal = (props) => {
  const {
    cancelPolicies,
    hotelLabels,
    policiesModalEvent,
    policiesModalVisible,
    paymentPolicies,
    roomTypeName
  } = props
  const cancelPolicyDescription = _.get(cancelPolicies, '[0].penaltyDescription.text')
  const paymentPolicyDescription = _.get(paymentPolicies, '[0].description.text')

  return (
    <div className="bk-flow-confirmation__reservation-property-policies">
      <button
        onClick={() => policiesModalEvent()}
        className="btn btn-text-only"
      >
        {hotelLabels.showRatePoliciesInformation ? hotelLabels.showRatePoliciesInformation : 'Show Rate Policies and Information'}
        {policiesModalVisible ? <span className="policy-hide">&nbsp;-</span> : <span className="policy-show">&nbsp;+</span>}
      </button>

      <Modal
        className={{
          base: 'bk-flow-confirmation__reservation-property-policies-modal u-modal u-modal--xs',
          afterOpen: 'u-modal--visible',
          beforeClose: 'u-modal--close',
          ariaHideApp: false
        }}
        overlayClassName={{
          base: 'u-fade',
          afterOpen: 'u-fade--visible',
          beforeClose: 'u-fade--visible'
        }}
        isOpen={policiesModalVisible}
        onRequestClose={policiesModalEvent}
        contentLabel="Confirmation Policies Modal"
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <div className="u-modal__header">
          <h5>
            {roomTypeName && roomTypeName + ' '}{hotelLabels.policies ? hotelLabels.policies : 'Policies'}
            <div
              className="u-modal__close u-font-small u-font-bold"
              onClick={() => policiesModalEvent()}
            >
              {hotelLabels.close ? hotelLabels.close : 'Close'}
              <i className="material-icons">close</i>
            </div>
          </h5>
        </div>

        <div className="u-modal__body">
          {cancelPolicyDescription &&
            <div className="policy-row cancel">
              <h6>{hotelLabels.cancelPolicy ? hotelLabels.cancelPolicy : 'Cancel Policy'}</h6>
              <p className="u-remove-margin">{cancelPolicyDescription}</p>
            </div>
          }

          {paymentPolicyDescription &&
            <div className="policy-row payment">
              <h6>{hotelLabels.paymentPolicy ? hotelLabels.paymentPolicy : 'Guarantee Policy'}</h6>
              <p className="u-remove-margin">{paymentPolicyDescription}</p>
            </div>
          }
        </div>
      </Modal>
    </div>
  )
}

export default BkFlowReservationPropertyPoliciesModal



// WEBPACK FOOTER //
// ./src/components/confirmation/elements/condensed/BkFlowReservationPropertyPoliciesModal.js